"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getFixedNumber = exports.updateFn = void 0;
var react_1 = require("react");
var defaultSecondPerStep = 1;
exports.updateFn = function (params) { return function (q) {
    var refreshCount = params.refreshCount, refreshCallback = params.refreshCallback;
    if (q === refreshCount) {
        if (refreshCallback) {
            refreshCallback();
        }
        return 0;
    }
    return q + 1;
}; };
exports.getFixedNumber = function (num) { return (Math.floor((num) * 100) / 100); };
var useInterval = function (params) {
    var refreshCount = params.refreshCount, _a = params.secondsPerStep, secondsPerStep = _a === void 0 ? defaultSecondPerStep : _a, refreshCallback = params.refreshCallback;
    var timerRef = react_1.useRef();
    var _b = react_1.useState(0), timeNow = _b[0], setTimeNow = _b[1];
    var _c = react_1.useState(0), secondsNow = _c[0], setSecsNow = _c[1];
    var secondsPerStepNow = Array.isArray(secondsPerStep) ?
        secondsPerStep[timeNow] :
        secondsPerStep;
    var handleRefresh = react_1.useCallback(function () {
        setTimeNow(function (s) {
            if (s >= refreshCount) {
                return 0;
            }
            return s + 1;
        });
        setSecsNow(0);
    }, [refreshCount]);
    var handleManualRefreshAll = react_1.useCallback(function () {
        // console.log('called');
        setTimeNow(0);
        setSecsNow(0);
        if (refreshCallback) {
            refreshCallback();
        }
    }, [refreshCallback]);
    var handleStartTime = react_1.useCallback(function () {
        timerRef.current = setInterval(function () {
            setSecsNow(function (s) { return exports.getFixedNumber(s + 0.1); });
        }, 1 * 100);
    }, []);
    var handleStopTime = react_1.useCallback(function () {
        timerRef.current && clearInterval(timerRef.current);
    }, []);
    react_1.useEffect(function () {
        if (secondsNow >= secondsPerStepNow) {
            handleRefresh();
        }
    }, [handleRefresh, secondsNow, secondsPerStepNow]);
    react_1.useEffect(function () {
        handleStartTime();
        return handleStopTime;
    }, [handleStartTime, handleStopTime]);
    // console.log(secondsNow, timeNow, secondsPerStepNow);
    return ({
        timeNow: timeNow,
        setTimeNow: setTimeNow,
        handleStartTime: handleStartTime,
        handleStopTime: handleStopTime,
        manualRefresh: handleManualRefreshAll
    });
};
exports.default = useInterval;
